
export enum PagePath
{
	INDEX = "/",
	ABOUT = "/about",
	PROJECTS = "/projects",
	TEAM = "/team"
}
